import { IdmissionFaceValidation } from './IdmissionFaceValidation';

export function VerifySelfiePage() {
  return <IdmissionFaceValidation />;
}

export default VerifySelfiePage;
